/**
 * isConvexId — guard a route/prop id before it reaches a Convex `v.id(...)`
 * validator. A malformed id (mock fixture ids like `as_13`, hand-typed URLs,
 * prototype placeholders like `sc_new`) thrown at a query produces an
 * uncaught ArgumentValidationError past the error boundary (white-screen).
 * Convex document ids are long lowercase-alphanumeric strings; anything else
 * should `'skip'` the query and let the screen's honest not-found/empty
 * state render instead.
 */
export const isConvexId = (s?: string | null): boolean =>
  !!s && /^[a-z0-9]{20,}$/.test(s);
